import React from 'react'

interface AddCellButtonProps {
    label: string
    onClick: () => void
}

const AddCellButton = ({ label, onClick }: AddCellButtonProps) => (
    <button className="add-cell-button" type="button" aria-label={label} onClick={onClick}>
        <span aria-hidden>＋</span>
        {label}
    </button>
)

export default AddCellButton
